import {useState} from "../../../__snowpack__/pkg/react.js";
import {createModel} from "../../../__snowpack__/pkg/hox.js";
import {axios} from "../../lib/axios.js";
import {handleError} from "../../lib/errorHandler.js";
export const useStockSetting = () => {
  const [data, setData] = useState();
  const [loading, setLoading] = useState(false);
  const fetchData = async () => {
    setLoading(true);
    try {
      const {data: data2} = await axios.get("/saas/stock/setting");
      setData(data2);
      return {
        stockSetting: data2
      };
    } catch (error) {
      handleError(error);
      return {
        stockSetting: data
      };
    } finally {
      setLoading(false);
    }
  };
  return {
    stockSettingLoading: loading,
    stockSetting: data,
    fetchStockSetting: fetchData
  };
};
export const useStockSettingModel = createModel(useStockSetting);
export const useStockSettingOld = () => {
  const [data, setData] = useState();
  const [loading, setLoading] = useState(false);
  const fetchData = async () => {
    setLoading(true);
    try {
      const {data: data2} = await axios.get("/saas/inventories/setting");
      setData(data2);
      return {
        stockSetting: data2
      };
    } catch (error) {
      handleError(error);
      return {
        stockSetting: data
      };
    } finally {
      setLoading(false);
    }
  };
  return {
    stockSettingOldLoading: loading,
    stockSettingOld: data,
    fetchStockSettingOld: fetchData
  };
};
export const useStockSettingOldModel = createModel(useStockSettingOld);
